<template>
	<div class="empty-state">
		<i :class="iconClass"></i>
		<p>{{ text }}</p>
	</div>
</template>

<script>
export default {
	name: 'EmptyState',
	props: {
		text: {
			type: String,
			default: '暂无数据'
		},
		iconClass: {
			type: String,
			default: 'inbox icon'
		}
	}
}
</script>

<style scoped>
.empty-state {
	padding: 18px 10px;
	text-align: center;
	color: #94a3b8;
	font-size: 13px;
}

.empty-state i {
	display: block;
	font-size: 22px;
	margin-bottom: 8px;
	color: #cbd5e1;
}

.empty-state p {
	margin: 0;
}
</style>
